import ExcelJS from 'exceljs'
import { saveAs } from 'file-saver'

const maxRow = 1000

const data = [
  {
    program: 'Self-Awareness :  Learning to control your emotions',
    task: 'Identify triggers',
    explanation:
      'Reflect on situations or events that typically trigger anger.',
    type: 'cai session',
    frequency: 'once',
    repeat: 1,
    notes: '',
  },
  {
    program: '',
    task: 'Explore underlying emotions',
    explanation:
      'Understand the root cause of anger (e.g., fear, insecurity, frustration).',
    type: 'cai session',
    frequency: 'once',
    repeat: 1,
    notes: 'repeat at the end of progam 2',
  },
  {
    program: '',
    task: 'Journaling',
    explanation: 'Track anger episodes and their impact on self and others.',
    type: 'IRL',
    frequency: 'once',
    repeat: 1,
    notes: 'repeat at the end of progam 2',
  },
  {
    program: 'Develop Coping Mechanisms',
    task: 'Mindfulness practice',
    explanation:
      'Learn to observe thoughts and feelings without judgment, allowing you to detach from emotions.',
    type: 'cai session',
    frequency: 'once',
    repeat: 0,
    notes: 'best to find a quiet place, possibly not at work at the begining',
  },
  {
    program: '',
    task: 'Cognitive restructuring',
    explanation:
      'Identify distorted thought patterns and replace them with more balanced perspectives.',
    type: 'cai session',
    frequency: 'once',
    repeat: 1,
    notes: 'best to find a quiet place, possibly not at work at the begining',
  },
  {
    program: '',
    task: 'Deep breathing exercises',
    explanation: 'Enhance your ability to manage stress and anxiety.',
    type: 'cai session',
    frequency: 'once',
    repeat: 1,
    notes: 'best to find a quiet place, possibly not at work at the begining',
  },
  {
    program: '',
    task: 'Progressive muscle relaxation',
    explanation: 'Release physical tension and calm your body.',
    type: 'cai session',
    frequency: 'once',
    repeat: 1,
    notes: '',
  },
  {
    program: 'Communication Skills',
    task: 'Active listening',
    explanation:
      'Practice attentive communication by focusing on the speaker and their needs.',
    type: 'cai session',
    frequency: 'once',
    repeat: 1,
    notes: '',
  },
  {
    program: '',
    task: 'Assertiveness training',
    explanation:
      'Learn to express your needs clearly and respectfully, while remaining respectful of others.',
    type: 'cai session',
    frequency: 'once',
    repeat: 1,
    notes: '',
  },
  {
    program: '',
    task: 'Non-violent communication',
    explanation:
      'Develop skills for expressing emotions in a healthy way, without aggression or blaming.',
    type: 'cai session',
    frequency: 'once',
    repeat: 1,
    notes: '',
  },
  {
    program: 'Professional Life Management',
    task: 'Set boundaries',
    explanation:
      "Communicate your work-life balance and respect colleagues' time.",
    type: 'cai session',
    frequency: 'once',
    repeat: 1,
    notes: '',
  },
  {
    program: '',
    task: 'Delegate tasks',
    explanation:
      'Identify areas where you can delegate responsibilities to reduce your workload and increase efficiency.',
    type: 'cai session',
    frequency: 'once',
    repeat: 1,
    notes: 'organisational task could be linked with other, dedicated program',
  },
  {
    program: '',
    task: 'Learn to say no',
    explanation:
      'Practice saying no to additional commitments if you are already feeling overwhelmed.',
    type: 'cai session',
    frequency: 'once',
    repeat: 1,
    notes: 'organisational task could be linked with other, dedicated program',
  },
  {
    program: '',
    task: 'Manage meetings effectively',
    explanation:
      'Prepare for meetings, stick to the agenda, and actively listen to others.',
    type: 'cai session',
    frequency: 'once',
    repeat: 1,
    notes: 'organisational task could be linked with other, dedicated program',
  },
]

const setupGoalPathwaySheet = (sheet, data = []) => {
  sheet.columns = [
    { header: 'Program', key: 'program', width: 40 },
    { header: 'Task', key: 'task', width: 40 },
    { header: 'Explanation', key: 'explanation', width: 50 },
    { header: 'Type', key: 'type', width: 15 },
    { header: 'Frequency', key: 'frequency', width: 12 },
    { header: 'Repeat', key: 'repeat', width: 12 },
    { header: 'Notes', key: 'notes', width: 30 },
  ]

  sheet.getRow(1).font = { bold: true }
  sheet.getRow(1).alignment = { vertical: 'middle', horizontal: 'center' }

  sheet.getColumn('type').alignment = { horizontal: 'center', wrapText: true }
  sheet.getColumn('frequency').alignment = {
    horizontal: 'center',
    wrapText: true,
  }
  sheet.getColumn('notes').alignment = { wrapText: true }

  sheet.getColumn('program').font = { name: 'Quattrocento Sans', size: 12 }
  sheet.getColumn('task').font = { name: 'Quattrocento Sans', size: 12 }
  sheet.getColumn('explanation').font = { italic: true, wrapText: true }

  sheet.getCell('A1').font = { name: 'Quattrocento Sans', size: 12, bold: true }
  sheet.getCell('B1').font = { name: 'Quattrocento Sans', size: 12, bold: true }
  sheet.getCell('C1').font = { italic: true, bold: true, wrapText: true }

  sheet.getCell('A1').note =
    'This will determine the context for the ai coach to conduct a task'
  sheet.getCell('B1').note = 'Used by the AI coach to guide the session or task'
  sheet.getCell('C1').note =
    'This will determine the context for the ai coach to conduct a task'
  sheet.getCell('D1').note = 'IRL= In Real Life, the coach only presents a task'
  sheet.getCell('E1').note = 'Use the dropdown to select'
  sheet.getCell('F1').note = 'Input a number between 0 and 30'
  sheet.getCell('G1').note =
    "These are creator's notes that are not shown to users"

  if (data.length) {
    data.forEach((row) => sheet.addRow(row))
  }

  const lastRow = maxRow
  for (let i = 2; i <= lastRow; i++) {
    sheet.getCell(`D${i}`).dataValidation = {
      type: 'list',
      allowBlank: false,
      formulae: ['"cai session,IRL"'],
      showErrorMessage: true,
      errorStyle: 'error',
      errorTitle: 'Invalid Type',
      error: 'Only one of the following values is allowed: cai session, IRL',
    }

    sheet.getCell(`E${i}`).dataValidation = {
      type: 'list',
      formulae: ['"once,once a week,once a day,twice a day"'],
      showErrorMessage: true,
      errorStyle: 'error',
      errorTitle: 'Invalid Frequency',
      error: 'Only "once","once a week","once a day","twice a day" is allowed.',
    }

    sheet.getCell(`F${i}`).dataValidation = {
      type: 'whole',
      operator: 'between',
      formulae: [0, 30],
      showErrorMessage: true,
      errorStyle: 'error',
      errorTitle: 'Invalid Value',
      error: 'Only integers from 0 to 30 is allowed.',
    }
  }

  sheet.getRow(1).eachCell((cell) => {
    cell.protection = { locked: true }
  })

  const lastCol = 7
  for (let row = 2; row <= lastRow; row++) {
    for (let col = 1; col <= lastCol; col++) {
      sheet.getCell(row, col).protection = { locked: false }
    }
  }

  return sheet
}

export const downloadTemplate = async () => {
  const workbook = new ExcelJS.Workbook()

  // Add a worksheet for the template
  const sheet = workbook.addWorksheet('GoalPathwayTemplate')
  setupGoalPathwaySheet(sheet, [])

  await sheet.protect('yourpassword', {
    selectLockedCells: false,
    selectUnlockedCells: true,
    formatCells: false,
    formatColumns: false,
    formatRows: false,
    insertColumns: false,
    deleteColumns: false,
    insertRows: true,
    deleteRows: false,
    sort: false,
    autoFilter: false,
    pivotTables: false,
  })

  // Add example sheet
  const exampleSheet = workbook.addWorksheet('Pathway example')
  setupGoalPathwaySheet(exampleSheet, data)

  await exampleSheet.protect('yourpassword', {
    selectLockedCells: false,
    selectUnlockedCells: true,
    formatCells: false,
    formatColumns: false,
    formatRows: false,
    insertColumns: false,
    deleteColumns: false,
    insertRows: true,
    deleteRows: false,
    sort: false,
    autoFilter: false,
    pivotTables: false,
  })

  // Add instructions sheet
  const instructionSheet = workbook.addWorksheet('Instructions')

  const instructions = [
    'This file is meant to be used as the structure of a goal pathway.',
    'It has been formatted to fit CognentAI’s systems and its structure should not be modified.',
    'Tab “Goals Template” is the one where new pathways can be created. Only the tab in first position is used by the system.',
    'Tab “Pathway example” is an example from one of the library. Any of the library templates can be downloaded and customized.',
    'The headers have comments attached to them for ease of understanding.',
    'Frequency: use the dropdown to select once/once a week/once a day/twice a day.',
    'Repeat: has to be a number between 0 and 30, combines with frequency for a total number of occurrences.',
  ]

  instructions.forEach((line) => {
    const row = instructionSheet.addRow([line])
    row.font = { name: 'Arial', size: 12 }
  })
  instructionSheet.getColumn(1).width = 150

  const buffer = await workbook.xlsx.writeBuffer()
  saveAs(new Blob([buffer]), 'template-goals.xlsx')
}

const allowedTypes = ['cai session', 'IRL']

export const validateExcel = async (file) => {
  const rowErrors = []
  const workbook = new ExcelJS.Workbook()
  await workbook.xlsx.load(await file.arrayBuffer())
  const sheet = workbook.worksheets[0]

  let currentProgram = ''
  const programTaskCount = {}

  sheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
    if (rowNumber === 1) return

    const program = row.getCell(1).value?.toString().trim() || ''
    const task = row.getCell(2).value?.toString().trim() || ''
    const explanation = row.getCell(3).value?.toString().trim() || ''
    const type = row.getCell(4).value?.toString().trim() || ''
    const frequency = row.getCell(5).value?.toString().trim() || ''
    const repeat = row.getCell(6).value?.toString().trim() || ''
    const errors = []

    // Check and update currentProgram
    if (program) {
      currentProgram = program
      if (!programTaskCount[currentProgram]) {
        programTaskCount[currentProgram] = {
          row: rowNumber,
          taskCount: 0,
        }
      }
    }

    // Logic 3: Task must belong to a program
    if (task && !currentProgram) {
      errors.push('Task must belong to a declared Program.')
    }

    // Count task for current program if task exists
    if (task && currentProgram) {
      programTaskCount[currentProgram].taskCount++
    }

    // Logic: Field validation
    if (!program && !task && !explanation) return // skip empty row

    if (!task) errors.push('Task is required.')
    if (!explanation) errors.push('Explanation is required.')
    if (!type) {
      errors.push('Type is required.')
    } else if (!allowedTypes.includes(type)) {
      errors.push(`Type must be one of: ${allowedTypes.join(', ')}`)
    }
    if (!frequency) {
      errors.push('Frequency is required.')
    } else if (
      !['once', 'once a week', 'once a day', 'twice a day'].includes(frequency)
    ) {
      errors.push(
        'Frequency must be "once","once a week","once a day","twice a day".',
      )
    }
    if (!repeat) {
      errors.push('Repeat is required.')
    } else if (repeat < 0 || repeat > 30) {
      errors.push('Repeat must be between 0 and 30.')
    }

    if (errors.length > 0) {
      rowErrors.push({
        row: rowNumber,
        error: errors.join('\n'),
      })
    }
  })

  Object.entries(programTaskCount).forEach(([program, { row, taskCount }]) => {
    if (taskCount > 0) return

    const existingError = rowErrors.find((error) => error.row === row)
    const msg = `Program "${program}" must have at least one task.`

    if (existingError) {
      existingError.error += `\n${msg}`
    } else {
      rowErrors.push({
        row: row,
        error: msg,
      })
    }
  })

  return rowErrors
}
